import Link from "next/link";
import SignatureSVG from "./SignatureSVG";

export default function AuthBrandPanel({
  headline,
  subtitle,
  stats,
}: {
  headline: React.ReactNode;
  subtitle?: string;
  stats?: { label: string; sublabel: string }[];
}) {
  return (
    <div className="auth-pattern auth-lines hidden lg:flex lg:w-1/2 flex-col justify-between p-12 relative overflow-hidden">
      {/* Logo */}
      <div className="relative z-10">
        <Link href="/" className="inline-block">
          <h1 className="font-display text-2xl font-bold text-white tracking-tight">
            Sign<span className="text-brand-500">Forge</span>
          </h1>
        </Link>
      </div>

      {/* Hero content */}
      <div className="relative z-10 max-w-md">
        <p className="font-editorial text-4xl lg:text-5xl font-bold text-white leading-tight">
          {headline}
        </p>
        {subtitle && (
          <p className="mt-5 text-slate-400 text-sm leading-relaxed">
            {subtitle}
          </p>
        )}
        {stats && (
          <div className="mt-8 flex gap-6">
            {stats.map((s, i) => (
              <div key={s.label} className="flex items-center gap-6">
                {i > 0 && <div className="h-10 w-px bg-white/10" />}
                <div>
                  <p className="font-display text-xl font-bold text-white">{s.label}</p>
                  <p className="text-xs text-slate-500">{s.sublabel}</p>
                </div>
              </div>
            ))}
          </div>
        )}
        <SignatureSVG className="mt-8 w-2/3 opacity-80" delay={0.5} />
      </div>

      {/* Copyright */}
      <div className="relative z-10">
        <p className="text-xs text-slate-500">
          &copy; {new Date().getFullYear()} SignForge &middot; Open-standards verified &amp; legally compliant
        </p>
      </div>

      {/* Floating orbs */}
      <div
        className="absolute top-[15%] left-[10%] h-3 w-3 rounded-full bg-[var(--color-gold)] opacity-20 animate-float"
        aria-hidden="true"
      />
      <div
        className="absolute top-[35%] right-[15%] h-2 w-2 rounded-full bg-[var(--color-gold)] opacity-15 animate-float-slow delay-1000"
        aria-hidden="true"
      />
      <div
        className="absolute bottom-[30%] left-[20%] h-4 w-4 rounded-full bg-[var(--color-gold)] opacity-10 animate-float-slower delay-2000"
        aria-hidden="true"
      />
      <div
        className="absolute top-[60%] right-[25%] h-2.5 w-2.5 rounded-full bg-[var(--color-gold)] opacity-15 animate-float delay-3000"
        aria-hidden="true"
      />

      {/* Decorative circles + line */}
      <div className="absolute -bottom-20 -right-20 h-64 w-64 rounded-full border border-white/5" aria-hidden="true" />
      <div className="absolute -bottom-10 -right-10 h-40 w-40 rounded-full border border-brand-500/10" aria-hidden="true" />
      <div className="absolute top-1/4 right-12 h-px w-24 bg-gradient-to-r from-brand-500/20 to-transparent" aria-hidden="true" />
    </div>
  );
}
